import "./ErrorOverlay.scss";
import React from "react";
import {Overlay} from "./Overlay";

export function ErrorOverlay({children}: {children: React.ReactNode}) {
    return <Overlay className="ErrorOverlay">{children}</Overlay>
}